module.exports = __webpack_public_path__ + "media/drum-sound.376b71f0.wav";